import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { isSameDay } from 'date-fns';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import colors from '@general/colors';
import { getDatesForDateRange } from '@general/dates';
import { LabelLarge } from '@styled';

const dateFormatLong = 'EEEE, MMMM d';
const dateFormatShort = 'yyyy-MM-dd';

const TabNavContainer = styled.div`
    border-bottom: 1px solid ${colors.lightGray};
    display: flex;
    overflow-x: scroll;
`;

const TavNavLink = styled.a`
    border: 1px solid ${colors.lightGray};
    border-radius: 8px 8px 0px 0px;
    padding: 12px 20px 7px 20px;

    &:not(:last-child) {
        margin-right: 8px;
    }

    &.active {
        border: none;
        background: ${colors.primary};
        color: #fff !important;
    }
`;

const EventDayTabs = ({ eventStartDate, eventEndDate, activeDay, onDayChange, children }) => {
    const [days, setDays] = useState([]);

    useEffect(() => {
        const datesForDateRange = getDatesForDateRange({
            startDate: eventStartDate,
            endDate: eventEndDate,
            dateFormatLong,
            dateFormatShort,
        });

        setDays(datesForDateRange);
    }, [eventStartDate, eventEndDate]);

    return (
        <div className="event-day-tabs">
            <TabNavContainer className="d-flex">
                {days.map(day => (
                    <TavNavLink
                        key={day.short}
                        href="#"
                        className={classnames({ active: isSameDay(day.date, activeDay) })}
                        onClick={e => {
                            e.preventDefault();
                            onDayChange(day.date);
                        }}
                    >
                        <LabelLarge>{day.long}</LabelLarge>
                    </TavNavLink>
                ))}
            </TabNavContainer>

            <div>{children}</div>
        </div>
    );
};

EventDayTabs.propTypes = {
    eventStartDate: PropTypes.instanceOf(Date).isRequired,
    eventEndDate: PropTypes.instanceOf(Date).isRequired,
    activeDay: PropTypes.instanceOf(Date).isRequired,
    onDayChange: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
};

export default EventDayTabs;
